import { createSelector } from "@reduxjs/toolkit";
import moment from "moment";
import { RootState } from "redux-store/store";

const declareLeaveSelector = (state: RootState) => state.declareLeave;

export const selectTimeCheckingData = createSelector(
  declareLeaveSelector,
  (state) => state.timeKeeping.data
);

export const selectMonthYearTimeCheckingData = createSelector(
  declareLeaveSelector,
  (state) => {
    return {
      month: state.timeKeeping.month,
      year: state.timeKeeping.year,
    };
  }
);

export const selectFormReqLeave = createSelector(
  declareLeaveSelector,
  (state) => state.formReqLeave
);
export const selectLongTermFormReqLeave = createSelector(
  selectFormReqLeave,
  (state) => state.longTerm
);

export const selectFormReqLongTermLeave = createSelector(
  selectFormReqLeave,
  (state) => state.longTerm
);

export const selectFormReqArrivingLateLeaveEarly = createSelector(
  declareLeaveSelector,
  (state) => state.formArrivingLate
);

export const selectListDataDetailArriveLate = createSelector(
  selectFormReqArrivingLateLeaveEarly,
  (state) => state.data.details
);

export const selectFormTypeReq = createSelector(
  declareLeaveSelector,
  (state) => state.formArrivingLate.data.type
);

export const selectLongTermFormReq = createSelector(
  declareLeaveSelector,
  (state) => state.formArrivingLate.longTerm
);

export const selectListArriveLateData = createSelector(
  declareLeaveSelector,
  (state) => state.listArriveLate.data
);

export const selectListArriveLateStatus = createSelector(
  declareLeaveSelector,
  (state) => state.listArriveLate.status
);

export const selectArriveLateDetailData = createSelector(
  declareLeaveSelector,
  (state) => state.arriveLateDetail.data
);

export const selectArriveLateDetailId = createSelector(
  declareLeaveSelector,
  (state) => state.arriveLateDetail.id
);

export const selectArriveLateDetailStatus = createSelector(
  declareLeaveSelector,
  (state) => state.arriveLateDetail.status
);
export const selectListReasonArriveLate = createSelector(
  declareLeaveSelector,
  (state) => state.listReasonArriveLate.data
);

export const selectListReasonLeave = createSelector(
  declareLeaveSelector,
  (state) => state.listReasonLeave.data
);

export const selectReasonLeave = createSelector(
  declareLeaveSelector,
  (state) => state.listReasonLeave
);

export const selectDirectionManager = createSelector(
  declareLeaveSelector,
  (state) => state.directionManager.data
);
export const selectListArriveLate = createSelector(
  declareLeaveSelector,
  (state) => state.listArriveLate.data
);

export const listRequestLeaveData = createSelector(
  declareLeaveSelector,
  (state) => state.listRequestLeave.data
);

export const selectListDataDetailReqLeave = createSelector(
  declareLeaveSelector,
  (state) => state.formReqLeave.data.details
);

export const selectRequestLeaveType = createSelector(
  declareLeaveSelector,
  (state) => state.formReqLeave.data.type
);

export const listRequestLeaveStatus = createSelector(
  declareLeaveSelector,
  (state) => state.listRequestLeave.status
);

export const uploadFileStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.uploadFile.status
);

export const selectListArriveLateConfig = createSelector(
  declareLeaveSelector,
  (state) => state.listArriveLateConfig.data
);

// danh sách người liên quan

export const selectNameEmployee = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployee.name
);
export const selectListEmployee = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployee.data
);

export const selectAttendanceDetail = createSelector(
  declareLeaveSelector,
  (state) => state.attendanceDetail
);

export const selectListArriveLateManager = createSelector(
  declareLeaveSelector,
  (state) => state.listArriveLateManager.data
);

export const selectListArriveLateManagerStatus = createSelector(
  declareLeaveSelector,
  (state) => state.listArriveLateManager.status
);

export const selectListRequestLeaveManager = createSelector(
  declareLeaveSelector,
  (state) => state.listRequestLeaveManager.data
);

export const selectListRequestLeaveManagerStatus = createSelector(
  declareLeaveSelector,
  (state) => state.listRequestLeaveManager.status
);

export const selectDeleteRequestStatus = createSelector(
  declareLeaveSelector,
  (state) => state.deleteRequest.status
);

export const selectDeleteRequestData = createSelector(
  declareLeaveSelector,
  (state) => state.deleteRequest.data
);

export const selectIdRequestLeaveDetail = createSelector(
  declareLeaveSelector,
  (state) => state.requestLeaveDetail.id
);

export const selectFormTypeReqLeave = createSelector(
  declareLeaveSelector,
  (state) => state.formReqLeave.data.type
);

export const selectRequestLeaveDetailData = createSelector(
  declareLeaveSelector,
  (state) => state.requestLeaveDetail.data
);

export const selectRequestLeaveDetailStatus = createSelector(
  declareLeaveSelector,
  (state) => state.requestLeaveDetail.status
);

export const selectPaidLeaveBalance = createSelector(
  declareLeaveSelector,
  (state) => state.paidLeaveBalance.data
);

export const selectTimeKeepingSummary = createSelector(
  declareLeaveSelector,
  (state) => state.timeKeepingSummary.data
);

export const selectHandleRequestStatus = createSelector(
  declareLeaveSelector,
  (state) => state.handleRequest.status
);

export const selectHandleRequestData = createSelector(
  declareLeaveSelector,
  (state) => state.handleRequest.data
);

export const selectMonthYearListLeave = createSelector(
  declareLeaveSelector,
  (state) => {
    return {
      month: state.listRequestLeave.month,
      year: state.listRequestLeave.year,
    };
  }
);

export const selectMonthYearListArriveLate = createSelector(
  declareLeaveSelector,
  (state) => {
    return {
      month: state.listArriveLate.month,
      year: state.listArriveLate.year,
    };
  }
);

export const selectMonthYearRequestLeave = createSelector(
  declareLeaveSelector,
  (state) => {
    return {
      month: state.listRequestLeaveManager.month,
      year: state.listRequestLeaveManager.year,
    };
  }
);

export const selectMonthYearListFeedback = createSelector(
  declareLeaveSelector,
  (state) => {
    return {
      month: state.getListFeedback.month,
      year: state.getListFeedback.year,
    };
  }
);

export const selectMonthYearListFeedbackManager = createSelector(
  declareLeaveSelector,
  (state) => {
    return {
      month: state.getListFeedbackManager.month,
      year: state.getListFeedbackManager.year,
    };
  }
);

export const selectMonthYearArriveLate = createSelector(
  declareLeaveSelector,
  (state) => {
    return {
      month: state.listArriveLateManager.month,
      year: state.listArriveLateManager.year,
    };
  }
);
export const selectListRequestLeaveConfig = createSelector(
  declareLeaveSelector,
  (state) => state.listRequestLeaveConfig
);

export const selectIsRequiredFile = createSelector(
  declareLeaveSelector,
  (state) => {
    const dataDetail = state.requestLeaveDetail?.data;
    return state.formReqLeave.data.details
      ?.filter((it) => {
        if (dataDetail?.details && dataDetail?.details?.length) {
          return dataDetail?.details?.some(
            (item) =>
              moment(item?.fromDate)?.toISOString() ===
              it?.fromDate?.toISOString()
          );
        } else {
          return it?.isNew;
        }
      })
      ?.some((it) => it.requireAttachFiles);
  }
);

export const selectCheckExitsStatus = createSelector(
  declareLeaveSelector,
  (state) => state.checkIsExitsReqArriveLate.status
);

export const selectCheckExitsReqLeaveStatus = createSelector(
  declareLeaveSelector,
  (state) => state.checkIsExitsReqLeave.status
);

export const selectFormLeaveManagerReq = createSelector(
  declareLeaveSelector,
  (state) => state.listLeaveManagerReq.formReq
);

export const selectDataLeaveManagerReq = createSelector(
  declareLeaveSelector,
  (state) => state.listLeaveManagerReq.data
);
export const getHolidaysDataSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getHolidays.data
);

export const listManagerOfDepartmentSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listManagerOfDepartment.data
);

export const timeCheckingMonthDataSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getTimekeepingMonth.data
);

export const timeCheckingMonthStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getTimekeepingMonth.status
);

export const listFeedbackStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getListFeedback.status
);

export const listFeedbackDataSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getListFeedback.data
);

export const listFeedbackManagerStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getListFeedbackManager.status
);

export const listFeedbackManagerDataSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getListFeedbackManager.data
);

export const sendFeedbackStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.sendFeedback.status
);

export const sendFeedbackDataSelector = createSelector(
  declareLeaveSelector,
  (state) => state.sendFeedback.data
);
export const minDateSelector = createSelector(
  declareLeaveSelector,
  (state) => state.configMinDate.data
);

export const startDateSelector = createSelector(
  declareLeaveSelector,
  (state) => state.configMinDate.startDate
);

export const defaultStartDateSelector = createSelector(
  declareLeaveSelector,
  (state) => state.configMinDate.defaultStartDate
);

export const formFilterTimeKeepingHRSelector = createSelector(
  declareLeaveSelector,
  (state) => state.formFilterTimeKeepingHR.filterInput
);

export const listTimeKeepingHRSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listTimeKeepingHR
);

export const categoryOptionSelector = createSelector(
  declareLeaveSelector,
  (state) => state.categoryOption
);

export const selectMonthYearTimeKeepingMonth = createSelector(
  declareLeaveSelector,
  (state) => {
    return {
      month: state.getTimekeepingMonth.month,
      year: state.getTimekeepingMonth.year,
    };
  }
);
// time keeping manager

export const formFilterTimeKeepingManagerSelector = createSelector(
  declareLeaveSelector,
  (state) => state.formFilterTimeKeepingManager.filterInput
);

export const listTimeKeepingManagerSelector = createSelector(
  declareLeaveSelector,
  (state) => state.timeKeepingManager.data
);

// confirm request
export const dataConfirmSelector = createSelector(
  declareLeaveSelector,
  (state) => state.confirmTimeKeeping.data
);

export const getFeedbackDetailDataSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getFeedbackDetail.data
);

export const getFeedbackDetailStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getFeedbackDetail.status
);

export const timeKeepingManagerDetailDataSelector = createSelector(
  declareLeaveSelector,
  (state) => state.timeKeepingManagerDetail.data
);

export const rangeTimeKeepingSelector = createSelector(
  declareLeaveSelector,
  (state) => state.rangeTimeKeeping.data
);

export const listEmployeeOfManagerSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployeeOfManager.data
);

export const listHrReportSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getHrReport
);

export const listHrReportStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getHrReport.status
);

export const formFilterHrReportSelector = createSelector(
  declareLeaveSelector,
  (state) => state.formFilterHrReport.filterInput
);

export const timeConfirmPeriodSelector = createSelector(
  declareLeaveSelector,
  (state) => state.timeConfirmPeriod.data
);

export const theFirstDataHrReportSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getHrReport.theFirstData
);

export const numberCanLateHrReportSelector = createSelector(
  declareLeaveSelector,
  (state) => state.getHrReport.value
);

// employee request

export const formFilterEmployeeLeaveSelector = createSelector(
  declareLeaveSelector,
  (state) => state.formFilterEmployeeLeave.filterInput
);

export const listEmployeeLeaveRequestSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployeeLeaveRequest.data
);

export const listEmployeeArriveLateRequestSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployeeArriveLateRequest.data
);

export const listEmployeeFeedbackRequestSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployeeFeedbackRequest.data
);

export const totalRecordsEmployeeLeaveRequestSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployeeLeaveRequest.totalRecords
);

export const totalRecordsEmployeeArriveLateRequestSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployeeArriveLateRequest.totalRecords
);

export const totalRecordsEmployeeFeedbackRequestSelector = createSelector(
  declareLeaveSelector,
  (state) => state.listEmployeeFeedbackRequest.totalRecords
);

export const employeeArriveLateDetailSelector = createSelector(
  declareLeaveSelector,
  (state) => state.employeeArriveLateDetail.data
);

export const employeeArriveLateDetailStatus = createSelector(
  declareLeaveSelector,
  (state) => state.employeeArriveLateDetail.status
);

export const employeeLeaveDetailSelector = createSelector(
  declareLeaveSelector,
  (state) => state.employeeLeaveDetail.data
);

export const employeeLeaveDetailStatus = createSelector(
  declareLeaveSelector,
  (state) => state.employeeLeaveDetail.status
);
export const employeeFeedbackDetailSelector = createSelector(
  declareLeaveSelector,
  (state) => state.employeeFeedbackDetail.data
);
export const employeeFeedbackDetailStatus = createSelector(
  declareLeaveSelector,
  (state) => state.employeeFeedbackDetail.status
);

export const timeCheckInOnlineSelector = createSelector(
  declareLeaveSelector,
  (state) => state.timeCheckInOnline
);
export const checkInOnlineSelector = createSelector(
  declareLeaveSelector,
  (state) => state.checkInOnline
);
export const checkInOnlineStatus = createSelector(
  checkInOnlineSelector,
  (state) => state.status
);
export const timeCheckInOnlineStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.timeCheckInOnline.status
);
export const timeCheckInOnlineDataSelector = createSelector(
  timeCheckInOnlineSelector,
  (state) => state.checkin
);

export const timeCheckOutOnlineDataSelector = createSelector(
  timeCheckInOnlineSelector,
  (state) => state.checkout
);

export const cancelRequestSelector = createSelector(
  declareLeaveSelector,
  (state) => state.cancelRequest
);

export const selectCancelRequestData = createSelector(
  cancelRequestSelector,
  (state) => state.data
);

export const selectCancelRequestStatus = createSelector(
  cancelRequestSelector,
  (state) => state.status
);

export const selectReasonCancelRequest = createSelector(
  cancelRequestSelector,
  (state) => state.reason
);

export const formInputImportSelector = createSelector(
  declareLeaveSelector,
  (state) => state.importTimekeeping.formInput
);

export const formEarlyRegistrationSelector = createSelector(
  declareLeaveSelector,
  (state) => state.earlyRegistration.formInput
);

export const isUpdateLeaveMaternityOrder = createSelector(
  declareLeaveSelector,
  (state) => state.updateLeaveMaternityOrder.isUpdateLeaveMaternityOrder
);

export const timeListConfigSelector = createSelector(
  declareLeaveSelector,
  (state) => state.updateLeaveMaternityOrder.timeListConfig
);

export const earlyRegistrationDeleteId = createSelector(
  declareLeaveSelector,
  (state) => state.deleteEarlyRegistration.id
);

export const earlyRegistrationDetailId = createSelector(
  declareLeaveSelector,
  (state) => state.earlyRegistrationDetail.id
);

export const createStatusRequestLeave = createSelector(
  declareLeaveSelector,
  (state) => state.createReqLeave.status
);

export const getManagerStatus = createSelector(
  declareLeaveSelector,
  (state) => state.listLeaveManagerReq.status
);

export const updateLeaveMaternityOrderStatusSelector = createSelector(
  declareLeaveSelector,
  (state) => state.updateLeaveMaternityOrder.status
);
